module.exports = __webpack_public_path__ + "static/media/varal-tradicional-parede.bb278dd5.png";